export default function ContactPage() {
  return (
    <div style={{ padding: "2rem", direction: "rtl" }}>
      <h1>צור קשר</h1>
      <p>נשמח לשמוע מכם!</p>
      <p>יש לכם שאלה, הצעה, או רעיון למאמר חדש?</p>
      <p>📧 פנו אלינו לכתובת: <a href="mailto:meitalbenshabat2@gmail.com">meitalbenshabat2@gmail.com</a></p>
    </div>
  );
}
